import { useMutation, useLazyQuery } from '@apollo/client/react';
/**
 * Wraps an async Apollo v4 result-returning function (a useMutation
 * mutate fn, or a useLazyQuery execute fn) so its resolved promise keeps
 * exposing the pre-v4 `.errors` array shape.
 *
 * v4 replaced `.errors` (array) with a single `.error`
 * (CombinedGraphQLErrors | network Error) on both MutateResult and
 * query results. This re-derives `.errors` from `.error` so existing
 * `if (result?.errors)` call sites keep working unchanged.
 *
 * TODO: remove once every call site checks `.error` directly.
 */
const withErrorsCompat = (fn) => async (...args) => {
  const res = await fn(...args);
  if (res?.error) {
    const errors = res.error?.errors ?? [res.error];
    return { ...res, errors };
  }
  return res;
};

export function useMutationCompat(mutation, options) {
  const [mutate, result] = useMutation(mutation, options);
  return [withErrorsCompat(mutate), result];
}

export function useLazyQueryCompat(query, options) {
  const [execute, result] = useLazyQuery(query, options);
  return [withErrorsCompat(execute), result];
}
